import React, { Component } from "react";

/** ---------- Text editor (class) ---------- */
export class TextEditor extends Component {
    render() {
        const { editorRef, onInput, onKeyDown, onPaste, isWriterMode, topContent, readOnly = false } = this.props;
        return (
            <div className={`editor-main${isWriterMode ? " writer-editor-main" : ""}`}>
                {topContent}
                <div
                    ref={editorRef}
                    className={`rich-editor${isWriterMode ? " writer-rich-editor" : ""}${readOnly ? " rich-editor--readonly" : ""}`}
                    contentEditable={!readOnly}
                    aria-readonly={readOnly}
                    suppressContentEditableWarning
                    onInput={onInput}
                    onKeyDown={onKeyDown}
                    onPaste={onPaste} />
            </div>
        );
    }
}
